import ThermalPrinterBase from "../../services/thermalPrinter/ThermalPrinterBase";
import PrintCustomNiceloopV1Builder from "~/class/printer/PrintCustomNiceloopV1Builder";


export default class ThermalPrintVoidReceipt extends ThermalPrinterBase {
    printVoidReceipt(payload: any) {
        this.print_data = this.withPayload(payload)
        return this
    }

    withPayload(payload: any) {
        return new PrintCustomNiceloopV1Builder().makeVoidReceipt(payload).build()
    }

    setPayload(payload: any) {
        this.print_data = payload
        return this
    }
}
